// countries where merchants are allowed to recover card fees (Fee Recovery)
export const feeRecoveryCountries = ['US', 'CA'];

export const isFeeRecoveryCountry = (country?: string | null): boolean =>
  !!country && feeRecoveryCountries.includes(country.toUpperCase());
